// Messages for the shared TagEditor (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'tags.add': 'Add tag',
  'tags.remove': 'Remove {label}',
  'tags.none': 'No tags',
  'tags.all_applied': 'All terms already applied.',
  'tags.empty_catalog': 'No taxonomy terms yet — define them in Settings → Taxonomies.',
  'tags.internal': 'Internal',
  'tags.internal_hint': 'Internal only — customers never see tags.',
}

export const zhTW = {
  'tags.add': '新增標籤',
  'tags.remove': '移除 {label}',
  'tags.none': '無標籤',
  'tags.all_applied': '所有詞彙皆已套用。',
  'tags.empty_catalog': '尚未建立分類詞彙——請於「設定 → 分類」中定義。',
  'tags.internal': '內部',
  'tags.internal_hint': '僅供內部——客戶不會看到標籤。',
}
